export default () => {

  /**
   * Tries to find a preceding heading element to associate with a facet
   */
  function ariaLabelByHeading(facetElement, labelTarget = facetElement) {
    let heading = facetElement.previousElementSibling;
    while (heading) {
      if (heading.tagName.match(/^H[1-6]$/)) {
        break;
      }

      heading = heading.previousElementSibling;
    }
    if (heading) {
      let id = heading.getAttribute('id');

      if (!id) {
        id = 'facetwp-heading-id-' + heading.textContent;
        id = id.trim().replace(/[\W_]+/g, '-').toLowerCase();
        heading.setAttribute('id', id);
      }

      labelTarget.setAttribute('aria-labelledby', id);
    }
  }

  function patchWpFacetAccessibility() {
    // Hierarchy type
    document.querySelectorAll('.facetwp-type-hierarchy').forEach(function(hierarchyElement) {
      hierarchyElement.setAttribute('role', 'radiogroup');

      ariaLabelByHeading(hierarchyElement);

      const items = hierarchyElement.querySelectorAll('.facetwp-link'),
            hasChecked = hierarchyElement.querySelectorAll('.checked').length
      ;

      items.forEach(function(item, itemIndex) {
        const checked = item.classList.contains('checked');
        let tabIndex = -1;

        if (checked || (itemIndex === 0 && !hasChecked)) {
          tabIndex = 0;
        }

        item.setAttribute('role', 'radio');
        item.setAttribute('aria-checked', checked);
        item.setAttribute('tabindex', tabIndex);
        item.addEventListener('keydown', radioButtonDown);
      });
    });
  }

  function radioButtonDown(event) {
    let target = null;

    switch (event.key) {
    // Enter, Space
    case 'Enter':
    case ' ':
      event.preventDefault();
      this.click();
      break;

    case 'ArrowLeft':
    case 'ArrowUp':
    case 'Left':
    case 'Up':
      target = this.previousSibling;

      if (!target && this.parentElement && this.parentElement.classList.contains('facetwp-depth')) {
        target = this.parentElement.previousSibling;
      }

      if (target && target.classList.contains('facetwp-depth')) {
        target = target.querySelector('[role="radio"]');
      }

      if (target) {
        event.preventDefault();
        target.focus();
      }

      break;

    // ArrowRight, ArrowDown
    case 'ArrowRight':
    case 'ArrowDown':
    case 'Right':
    case 'Down':
      target = this.nextSibling;

      if (!target && this.parentElement && this.parentElement.classList.contains('facetwp-depth')) {
        target = this.parentElement.nextSibling;
      }

      if (target && target.classList.contains('facetwp-depth')) {
        target = target.querySelector('[role="radio"]');
      }

      if (target) {
        event.preventDefault();
        target.focus();
      }

      break;
    }
  }

  $(document).on('facetwp-loaded', patchWpFacetAccessibility);

};
